import React from "react";
import { Box, Card, CardContent, Typography, Grid } from "@mui/material";
import { Title } from "react-admin";
import  HeroImage from "./images/app-admin.jpeg"
import CollectionsImage from "./images/ci-product-collections.png"
import AssociateIpad from "./images/two-people-ipad.jpeg";
import CustomerDetails from "./images/customer-details.png";

const MMAdminWelcomePage = () => (
  <Box sx={{ padding: "20px" }}>
    <Title title="Welcome to Mad Mobile Admin" />
    {/* Hero Section */}
    <Card
      sx={{
        marginBottom: "20px",
        textAlign: "center",
        padding: "40px",
        background: "linear-gradient(to right, #fff, #f0f0f0)",
        boxShadow: "none",
        borderRadius: "12px",
      }}
    >
      <img
        src={HeroImage}
        alt="Concierge AI"
        style={{ width: "80%", height: "auto", objectFit: "contain", marginBottom: "20px" }}
      />

      <Typography
        variant="h2"
        component="h1"
        gutterBottom
        sx={{ fontWeight: "bold", fontSize: "2.5rem", lineHeight: "1.2" }}
      >
        Manage Tenants, Brands and Environments
      </Typography>
      <Typography
        variant="h6"
        component="p"
        gutterBottom
        sx={{ color: "#555", marginBottom: "20px" }}
      >
        A central hub to manage Mad Mobile customer's environments to provision, configure and deploy solutions and observe and support applications.
      </Typography>
    </Card>
  </Box>
);

export default MMAdminWelcomePage;